import React, { useEffect, useState } from "react";
import _ from "lodash";
import App from "./App";
import { listApplications } from "../api/APIUtils";
import { useHistory } from "react-router-dom";
import SearchField from "./AppSearch";
import { Alert } from "react-bootstrap";
import useLocalStorage from "../hooks/useLocalStorage";
const AppsList = ({isAdmin }) => {
  const [apps, setApps] = useState([]);
  const [localApps, setLocalApps] = useLocalStorage("apps", []);

  const history = useHistory();
  const [Search, setSearch] = useState("");
  const [deleted, setDeleted] = useState(false);
  const [error, setError] = useState("");
  const handleChange = (e) => {
    setSearch(e.target.value);
  };
  const deleteApp = (id) => {
    const updatedApps = apps.filter((app) => {
      return app.id !== id;
    });
    setApps(updatedApps);
    setDeleted(true);
  };
  const handleError = (message) => {
    setError(message);
  };
  useEffect(() => {
    let isApiSubscribed = true;
    console.log({isAdmin})
    listApplications().then((res) => {
      if (isApiSubscribed) {
        setApps(_.get(res, "data.listApplications.items"));
        setLocalApps(_.get(res, "data.listApplications.items"));
      }
    });
    // updateApplication().then(res=> { console.log(res)})
    return () => {
      setDeleted(false);
      isApiSubscribed = false;
    };
  }, [history, deleted]);

  return (
    <React.Fragment>
      <br></br>
      <SearchField
        value={Search}
        placeholder="Search by plan name and tags (separate terms with spaces)..."
        handleChange={handleChange}
      />
      <br></br>
      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          <p>{error}</p>
        </Alert>
      )}
      <div className="app-list">
        {Search && apps
          ? apps
              .filter((app) => {
                const searchTerms = Search.toLowerCase().split(' ').filter(term => term.trim());
                const searchableText = [
                  app.name,
                  ...(app.tags || [])
                ].filter(Boolean).join(' ').toLowerCase();
                
                return searchTerms.every(term => searchableText.includes(term));
              })
              .map((app) => (
                <App
                  isAdmin={isAdmin}
                  deleteApp={deleteApp}
                  handleError={handleError}
                  apps={apps}
                  key={app.id}
                  {...app}
                  reload={console.log}
                />
              ))
          : _.map(apps, (app) => (
              <App
                isAdmin={isAdmin}
                deleteApp={deleteApp}
                handleError={handleError}
                apps={apps}
                key={app.id}
                {...app}
                reload={console.log}
              />
            ))}
      </div>
    </React.Fragment>
  );
};
export default AppsList;
